import React from 'react'
import style from '@aytm/app/swidget/base/questions/Ecommerce/Amazon/amazon.module.scss'
import useSurveyLocale from '../../../modules/locale/useSurveyLocale'
import { IEcommerceQuestionSchema, EcommerceResponse } from '../types'
import { getMediumAssetPath } from '@aytm/lib/common/assets'
import { formatPriceWithLocale } from '../utils/formatPriceWithLocale'
import ProductActions from './ViewComponents/ProductActions'

interface IRightColumnProps {
  response: EcommerceResponse
  openCart: () => void
  onProductAction: (qnt: -1 | 1, index: string, subscribe?: number) => void
  subTotal: number
  schema: IEcommerceQuestionSchema
  onItemSelect: (index: number) => void
}
const RightColumn = ({ response, subTotal, openCart, schema, onProductAction, onItemSelect }: IRightColumnProps) => {
  const { t, languageTag } = useSurveyLocale()

  return (
    <div className={style.rightColumn}>
      <div className={style.subtotal}>
        <span className={style.label}>{t('questions', 'ec', 'amazon', 'subTotalPrice')}</span>
        <br />
        <span
          className={style.value}
          dangerouslySetInnerHTML={{
            __html: formatPriceWithLocale(subTotal, schema.price_mask, languageTag, true, false)
          }}
        />
        <div onClick={openCart} className={style.goToCart}>
          {t('questions', 'ec', 'amazon', 'goToCart')}
        </div>
      </div>
      {response.answers.map((r, ri) => {
        const answer = schema.answers.find(answer => answer.id === r.id)
        const answerIndex = schema.answers.findIndex(answer => answer.id === r.id)
        if (!answer) return null
        return (
          <div key={ri}>
            {r.v > 0 ? (
              <div className={style.rightPreview}>
                <div className={style.imageContainer} onClick={() => onItemSelect(answerIndex)}>
                  <img
                    data-testid="SW-SH-ECommerceImagePreview"
                    className={style.preview}
                    alt={answer.image?.alt_text || t('questions', 'img', 'noAlt')}
                    src={getMediumAssetPath(answer.image, 'transparent')}
                  ></img>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: formatPriceWithLocale(r.price * r.v, schema.price_mask, languageTag, true, false)
                    }}
                  />
                  {schema.max_qty_per_product > 0 ? (
                    <span className={style.leftInStock}>
                      {t<(left: number) => string>(
                        'questions',
                        'ec',
                        'amazon',
                        'leftInStock'
                      )(schema.max_qty_per_product)}
                    </span>
                  ) : (
                    ''
                  )}
                  <div className={style.overlay} />
                </div>
                <ProductActions
                  isMobile={false}
                  response={r}
                  findability={false}
                  index={answerIndex}
                  limit={schema.max_qty_per_product}
                  onProductAction={onProductAction}
                  onSpin={() => {}}
                />
              </div>
            ) : null}
          </div>
        )
      })}
    </div>
  )
}

export default RightColumn
